import Login from "./pages/Login";
import Signup from "./pages/Signup";
import PaymentResponse from "./pages/PaymentResponse";
import SubscriptionDetail from "./pages/SubscriptionDetail";
import LandingPage from "./pages/LandingPage";
import BeehiveLanding from "./pages/beehive/BeehiveLanding";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermOfService from "./pages/TermOfService";
import ContactUs from "./pages/ContactUs";
import RootLayout from "./RootLayout";
import { createBrowserRouter, Navigate } from "react-router";
import ScrollToTop from "./components/ScrollToTop";
import Page404 from "./pages/Page404";
import Projects from "./pages/Projects";
import AboutUs from "./pages/AboutUs";
import Subscription from "./pages/Subscription";
import Profile from "./pages/Profile";
import Cart from "./pages/Cart";

// Create the Router
const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <>
        {/* <ScrollToTop /> */}
        <RootLayout />
      </>
    ),
    children: [
      { path: "/", element: <BeehiveLanding /> },
      { path: "/wroot", element: <LandingPage /> },
      {path: "/projects", element: <Projects />},
      { path: "/about-us", element: <AboutUs /> },
      { path: "/contact-us", element: <ContactUs /> },
      { path: "/page-not-found", element: <Page404 /> },
      { path: "/login", element: <Login /> },
      { path: "/signup", element: <Signup /> },
      { path: "/subscribe", element: <Subscription/> },
      { path: "/payment-successful", element: <PaymentResponse /> },
      { path: "/payment-cancelled", element: <PaymentResponse /> },
      { path: "/subscription-detail", element: <SubscriptionDetail /> },
      {path: "/cart", element: <Cart />},
      { path: "/privacy-policy", element: <PrivacyPolicy /> },
      { path: "/terms-of-service", element: <TermOfService /> },
      { path: "/profile", element: <Profile /> },
      { path: "*", element: <Navigate to="/page-not-found" replace /> },
    ],
  },
]);

export default router;
